export const BAGGAGE_LIST_ACTION = "BAGGAGE_LIST_ACTION";
export const BAGGAGE_ALL_LIST_ACTION = "BAGGAGE_ALL_LIST_ACTION";
export const BAGGAGE_LIST_SUCCESS = "BAGGAGE_LIST_SUCCESS";
export const BAGGAGE_LIST_FAIL = "BAGGAGE_LIST_SUCCESS";

export const BAGGAGE_DETAIL_ACTION = "BAGGAGE_DETAIL_ACTION";
export const BAGGAGE_DETAIL_SUCCESS = "BAGGAGE_DETAIL_SUCCESS";

export const BAGGAGE_DETAIL_CREATE_ACTION = "BAGGAGE_DETAIL_CREATE_ACTION";
export const BAGGAGE_DETAIL_UPDATE_ACTION = "BAGGAGE_DETAIL_UPDATE_ACTION";
export const BAGGAGE_DETAIL_DELETE_ACTION = "BAGGAGE_DETAIL_DELETE_ACTION";
export const BAGGAGE_DETAIL_FAIL = "BAGGAGE_DETAIL_FAIL";